<template>
  <div class="goodsUnpacklist">
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :disablePage="disablePage"
      :count="count"
      :current="page"
    >
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          <!-- <label>商品搜索:</label>
          <lk-input class="item" v-model="query.nameMix" clearable placeholder="可按商品名、通用名、编码、助记码搜索" /> -->
        </div>
        <div class="queryItem">
          <label>拆零时间段:</label>
          <timeStampDatePicker type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.unpackTimeRange' ></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>操作人:</label>
          <lk-input class="item" v-model="query.createUserName" clearable placeholder="请输入" />
        </div>
        <div class="queryItem" v-if="roleType!==2">
          <label>门店:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="search-btn" @click="handleSearch">查询</lk-button>
          <lk-button @click="clear">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' icon='md-add' @click="addNew" v-if="handlePermission('unpackAdd')">新建拆零</lk-button>
          <DownloadButton @on-click="download" v-if="handlePermission('unpackExport')"></DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import unpack from '../../services/unpack';
import utils from '../../libs/utils';

import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'unpack',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton,
  },
  data() {
    return {
      query: {},
      columns: [
        {
          title: '创建时间', key: 'createTime', minWidth: 116, tooltip: true, fixed: 'left',
        },
        {
          title: '商品名称', key: 'approvedDrugName', minWidth: 116, tooltip: true, fixed: 'left',
        },
        {
          title: '规格', key: 'spec', minWidth: 116, tooltip: true, fixed: 'left',
        },
        {
          title: '生产厂家', key: 'producer', minWidth: 116, tooltip: true, fixed: 'left',
        },
        {
          title: '生产批号', key: 'goodsBatchNumber', minWidth: 116, tooltip: true,
        },
        {
          title: '有效日期', key: 'goodsExpiryDate', minWidth: 116, tooltip: true,
        },
        {
          title: '原单位', key: 'drugMiniPackageUnitString', minWidth: 116, tooltip: true,
        },
        {
          title: '原数量', key: 'originNum', minWidth: 116, tooltip: true,
        },
        {
          title: '拆零单位', key: 'unpackMinPkgUnitName', minWidth: 116, tooltip: true,
        },
        {
          title: '拆零数量', key: 'unpackNum', minWidth: 116, tooltip: true,
        },
        {
          title: '拆零单价', key: 'unpackRetailPrice', minWidth: 116, tooltip: true,
        },
        {
          title: '拆零经办人', key: 'createUserName', minWidth: 116, tooltip: true,
        },
        {
          title: '复核人', key: 'reviewerName', minWidth: 116, tooltip: true,
        },
        {
          title: '销售完毕日期', key: 'emptyTime', minWidth: 116, tooltip: true,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'unpackAdd' });
    },
    paramsChange() {
      if (this.params.unpackTimeRange && this.params.unpackTimeRange.length === 2) {
        this.params.createTimeStart = this.params.unpackTimeRange[0];
        this.params.createTimeEnd = this.params.unpackTimeRange[1];
      }
    },
    download() {
      this.paramsChange();

      this.params.queryCondition = utils.getQueryCondition('.queryContainer');
      unpack.downloadUnpackReport(this.params)
        .then((res) => {
          if (res.data.error) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.size = this.size;
      this.params.page = this.page;
      this.paramsChange();
      unpack.getInventoryUnpackList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          const { data } = res.data;
          this.count = data.count;
          data.list.forEach((item) => {
            const itemTemp = {};
            if (item.goodsInfoVo) {
              const {
                approvedDrugName,
                spec,
                producer,
                drugMiniPackageUnitString,
              } = item.goodsInfoVo;
              Object.assign(itemTemp, {
                approvedDrugName,
                spec,
                producer,
                drugMiniPackageUnitString,
              });
            }

            if (item.unpackInventory) {
              const {
                goodsBatchNumber,
                goodsExpiryDate,
                emptyTime,
              } = item.unpackInventory;
              Object.assign(itemTemp, {
                goodsBatchNumber,
                goodsExpiryDate: utils.exchangeTime(goodsExpiryDate),
                emptyTime: utils.exchangeTime(emptyTime),
              });
            }

            if (item.inventoryUnpackRecord) {
              const {
                originNum,
                unpackMinPkgUnitName,
                unpackNum,
                unpackRetailPrice,
                createUserName,
                storeName,
                createTime,
                reviewerName,
              } = item.inventoryUnpackRecord;
              Object.assign(itemTemp, {
                originNum,
                reviewerName,
                unpackMinPkgUnitName,
                unpackNum,
                unpackRetailPrice,
                createUserName,
                storeName,
                createTime: utils.exchangeTimeToSecond(createTime),
              });
            }
            this.tableData.push(itemTemp);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        unpackTimeRange: [],
      };
    },
  },
  created() {
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店', key: 'storeName', minWidth: 116, tooltip: true, fixed: 'left',
      });
    }
    this.handleSearch(true);
  },
};
</script>

<style lang="less">
.goodsUnpacklist {
  .search-btn {
    margin-right: 10px;
  }
  .query-params-wrap {
    padding-bottom: 20px;
  }
  .second-row {
    margin-top: 10px;
  }
  .btns{
    display: flex;
    // justify-content: space-between;
    margin-bottom: 12px;
    // padding-top: 16px;
    div:last-child>*{
      margin-left: 16px
    }
    >*{
      margin-right: 16px
    }
  }
}

</style>
